<div class="input-group" [formGroup]="currencyFormGroup">
    <div class="input-group-text">
        {{ currencySymbol }}
    </div>
    <input
        wdxInputText
        currencyMask
        type="text"
        inputmode="decimal"
        autocomplete="off"
        class="form-control"
        formControlName="amount"
        [attr.id]="controlName"
        [attr.required]="isRequired"
        [options]="currencyMaskConfig"
        [attr.placeholder]="currencyPlaceholder"
    />
    @if (currencies$ | ngrxPush; as currencies) {
        <ng-select
            formControlName="isoCode"
            bindLabel="isoCode"
            [items]="currencies"
            [compareWith]="compareSelectedCurrency"
            [clearable]="false"
        ></ng-select>
    }
</div>
